import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import supabase from '../supabase';

export default function NotFoundPage() {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/sign-in');
  };

  return (
    <div className="flex flex-col min-h-[100dvh] items-center justify-center bg-background p-4">
      <div className="text-center space-y-6">
        <h1 className="text-4xl font-bold">404</h1>
        <p className="text-xl text-muted-foreground">Page not found</p>
        <div className="space-y-2">
          <Button onClick={() => navigate(-1)} className="w-full">
            Go Back
          </Button>
          <Button variant="outline" onClick={handleSignOut} className="w-full">
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
}
